import React from 'react';
import PropTypes from 'prop-types';
import './ProgressBar.scss';

const getColorClassName = (step, currentStep) => {
  if (step === currentStep) {
    return 'progressbar-box-current';
  }
  if (step > currentStep) {
    return 'progressbar-box-next';
  }
  return 'progressbar-box-previous';
};

const handleProgressBarBoxClick = (step, handleClick, disableClick) => (event) => {
  event.preventDefault();
  if (!disableClick) {
    handleClick(step);
  }
};

const ProgressBarBox = (props) => {
  const { last, step, currentStep, handleClick, disableClick } = props;
  return (
    <a
      href={!disableClick && step < currentStep ? '/checkout' : null}
      onClick={handleProgressBarBoxClick(step, handleClick, disableClick)}
    >
      <div className="progressbar-box-container">
        <div className={`progressbar-box-text ${getColorClassName(step, currentStep)}`}>{step}</div>
        <div className={`progressbar-box-top ${getColorClassName(step, currentStep)}`} />
        <div className={`progressbar-box-bottom ${getColorClassName(step, currentStep)}`} />
        {last &&
        <div className={`progressbar-box-last-top ${getColorClassName(step, currentStep)}`} />
        }
        {last &&
        <div className={`progressbar-box-last-bottom ${getColorClassName(step, currentStep)}`} />
        }
      </div>
    </a>
  );
};

ProgressBarBox.propTypes = {
  last: PropTypes.bool,
  step: PropTypes.number,
  currentStep: PropTypes.number,
  handleClick: PropTypes.func,
  disableClick: PropTypes.bool
};

const ProgressBar = props => (
  <div className="container">
    <div className="row">
      {!props.hidden &&
      <div className="col-xs-12">
        <div className="progressbar-container">
          {
            [1, 2, 3, 4].map(i =>
              <ProgressBarBox
                key={`step-${i}`}
                last={i === 4}
                step={i}
                {...props}
              />)
          }
        </div>
      </div>
      }
    </div>
  </div>
);

ProgressBar.propTypes = {
  hidden: PropTypes.bool
};

ProgressBar.defaultProps = {
  hidden: false
};

export default ProgressBar;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/ProgressBar/ProgressBar.js
 **/